import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Note } from '../models/note.model';
import { ConfigService } from '@xilo-mono/common/config';
import { map } from 'rxjs/operators';

@Injectable()
export class NoteService {
  apiUrl = `${this.configService.apiUrl}/note`;
  noteTypes = [
    { id: 'internal_note', value: 'Internal Note' },
    { id: 'call', value: 'Call' },
    { id: 'email', value: 'Email' },
    { id: 'sms', value: 'SMS' },
    { id: 'activity', value: 'Activity' },
    { id: 'in_person', value: 'In-Person' },
    { id: 'other', value: 'Other' },
  ];

  constructor(private http: HttpClient, private configService: ConfigService) {}

  //delete a Note
  delete(note: Note) {
    return this.http.delete(`${this.apiUrl}/${note.id}`);
  }

  // Get one Note
  get(note: Note) {
    const noteId = note ? `/${note.id}` : '';
    return this.http.get(this.apiUrl + noteId);
  }

  // Get all Client Notes
  getByClient(id: string) {
    return this.http.get(`${this.apiUrl}/client/${id}`).pipe(
      map((res) => {
        return res['obj'];
      })
    );
  }

  // Update a Note
  patch(note: Note) {
    const noteId = note.id ? `/${note.id}` : '';
    if (note.id) {
      return this.http.patch(this.apiUrl + noteId, note);
    }
  }

  // Create a new note
  post(note: Note) {
    return this.http.post(this.apiUrl, note);
  }
}
